module.exports = __webpack_public_path__ + "static/media/OpenHH808.a46a6e9a.wav";